import { lingo3g } from "../service/algorithms/lingo3g.js";

const lingo3gAlgorithm = {
  Lingo3G: lingo3g
};

export const algorithms = lingo3gAlgorithm;
